import { css, keyframes } from "styled-components";
import { AccordionItem } from "../../components/AccordionItem";
import { AccordionContent } from "../../components/AccordionContent";
import { AccordionTrigger } from "../../components/AccordionTrigger";
import { MixinIcon } from "../../../Icon/skins/common";
import { cssFontFamilySansSerif } from "../../../../skins/league-client/mixins/typography";
import { RichText } from "../../../RichText";
const slideDown = keyframes `
  0% {
    height: 0;
  }
  99% {
    height: var(--radix-accordion-content-height);
  }
  100% {
    height: auto;
  }
`;
const slideUp = keyframes `
  0% {
    height: var(--radix-accordion-content-height);
  }
  100% {
    height: 0;
  }
`;
export const leagueClientSkin = (chroma) => css `
  h3 button {
    ${chroma.typography.h3};
    color: ${chroma.palette.gold1} !important;
  }

  ${AccordionItem} {
    border-bottom: 1px solid ${chroma.palette.gold1};
    padding: 24px 0;
  }

  ${AccordionItem}:first-child {
    border-top: 1px solid ${chroma.palette.gold1};
  }

  ${AccordionTrigger} {
    & .trigger-text {
      width: calc(100% - 24px);
    }

    & .trigger-icon {
      height: 24px;
      width: 24px;
      ${MixinIcon({ icon: chroma.icons.accordionPlus, color: chroma.palette.gold1 })};
    }

    &[data-state="open"] .trigger-icon {
      ${MixinIcon({ icon: chroma.icons.accordionMinus, color: chroma.palette.gold1 })};
    }
  }

  ${AccordionContent} {
    ${chroma.typography.textLarge};
    color: ${chroma.palette.gold1};
    overflow: hidden;
    padding-top: 20px;
    ${cssFontFamilySansSerif}

    &[data-state="open"] {
      animation: ${slideDown} 300ms cubic-bezier(0.87, 0, 0.13, 1);
      animation-fill-mode: forwards;
    }

    &[data-state="closed"] {
      animation: ${slideUp} 300ms cubic-bezier(0.87, 0, 0.13, 1);
      animation-fill-mode: forwards;
    }

    ${RichText} {
      padding-top: 20px;

      p {
        padding: 0;
      }
    }

    & > p:not(:first-child) {
      margin-top: 20px;
    }

    & ul,
    ol {
      padding-top: 20px;
      padding-left: 20px;
    }

    & ul {
      list-style: disc;
    }

    & ol {
      list-style: decimal;
    }
  }
`;
//# sourceMappingURL=index.js.map